
import { Component, Vue } from 'vue-property-decorator';
import VWidget from '@/components/VWidget.vue';
import Ajax from '@/lib/ajax';
import Util from '@/lib/util';

@Component({ components: { VWidget } })
export default class CampaignMasterVins extends Vue {
    loading = false;
    importing = false;
    file: File | null = null;
    search = '';
    vins: any[] = [];
    headers = [
        { text: 'VIN', value: 'vin' },
        { text: 'Fecha de venta', value: 'sale_date' },
        { text: 'Vendido por', value: 'sold_by' },
        { text: 'Código Dealer', value: 'dealer' },
        { text: 'Modelo', value: 'model' },
    ];

    created() { this.load(); }

    async load() {
        this.loading = true;
        try {
            const response = await Ajax.get('/api/campaign-master-vins', { params: { search: this.search } });
            this.vins = response.data.result.data;
        } finally { this.loading = false; }
    }

    async importVins() {
        if (!this.file) return;
        this.importing = true;
        try {
            const data = new FormData();
            data.append('file', this.file);
            const response = await Ajax.post('/api/campaign-master-vins/import', data);
            const result = response.data.result;
            Util.abp.notify.success(this, `${result.created} VIN creados y ${result.updated} actualizados`);
            this.file = null;
            await this.load();
        } finally { this.importing = false; }
    }

    async downloadTemplate() {
        const response = await fetch(`${(Ajax.defaults as any).baseURL}/api/campaign-master-vins/template`, {
            headers: { Authorization: `Bearer ${window.abp.auth.getToken()}` },
        });
        if (!response.ok) throw new Error('No se pudo descargar la plantilla');
        const blob = await response.blob();
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'plantilla-maestro-vins.xlsx';
        link.click();
        URL.revokeObjectURL(link.href);
    }
}
